import React from 'react';
import { AFFIRM_PUBLIC_API_KEY, AFFIRM_SCRIPT_URL } from '@reverbdotcom/env';
import windowWrapper from '@reverbdotcom/commons/src/window_wrapper';

export function useAffirm() {
  React.useEffect(() => {
    buildOrReuseAffirmScript();
  }, []);

  return { affirm: windowWrapper.affirm };
}

function buildOrReuseAffirmScript() {
  const script = document.querySelector(`script[src="${AFFIRM_SCRIPT_URL}"]`);

  if (script) {
    return;
  }

  buildAffirmScript();
}

function buildAffirmScript() {
  const affirmConfig = {
    public_api_key: AFFIRM_PUBLIC_API_KEY,
    script: AFFIRM_SCRIPT_URL,
  };
  // Affirm vendor code. The one-liner is taken from their site: https://docs.affirm.com/payments/docs/checkout-web
  // eslint and TS checks are disabled for this block since the vendor code contains multiple type errors.
  /* eslint-disable */
  (function (m, g, n, d, a, e, h, c) {
    // @ts-ignore
    var b = m[n] || {}, k = window.document.createElement(e), p = window.document.getElementsByTagName(e)[0], l = function (a, b, c) { return function () { a[b]._.push([c, arguments]) } }; b[d] = l(b, d, "set"); var f = b[d]; b[a] = {}; b[a]._ = []; f._ = []; b._ = []; b[a][h] = l(b, a, h); b[c] = function () { b._.push([h, arguments]) }; a = 0; for (c = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < c.length; a++)f[c[a]] = l(b, d, c[a]); a = 0; for (c = ["get", "token", "url", "items"]; a < c.length; a++)f[c[a]] = function () { }; k.async = !0; k.src = g[e]; p.parentNode.insertBefore(k, p); delete g[e]; f(g); m[n] = b
    // eslint-disable-next-line @typescript-eslint/quotes
  })(window, affirmConfig, "affirm", "checkout", "ui", "script", "ready", "jsReady");
  /* eslint-enable */
}
